export default "__VITE_ASSET__De_qHzO4__"